<template>
  
    <div
      class="login-container"
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        padding: 0.5em 2em;
        height: 100%;
      "
  
    >
      <FormHeader title="text.login_title" secondaryTitle="text.login_subtitle" />
      <div
        class="form"
        style="
          background-color: #ecf4f6;
          padding: 5%;
          display: flex;
          flex-direction: column;
          align-items: stretch;
          gap: 10px;
          margin: 2%;
          border-radius: 0.5em;
        "
      >
        <input
          v-model="email"
          type="email"
          style="flex: 1;"
          placeholder="Adresse e-mail"
          :style="validationErrors.email ? errorStyles : defaultStyles"
          @blur="validateField('email', emailPattern)"
          :disabled="passwordForgotStep === 'code' || passwordForgotStep === 'password'"
          v-if="passwordForgotStep === 'email'"
        />
        <div
          style="display: flex;"
        class="otp-container" v-else-if="passwordForgotStep === 'code'">
          <input v-for="index in 6" :key="index" 
                v-model="otp[index - 1]" 
                class="otp-input" 
                type="text"
                maxlength="1" 
                @input="onOtpInput($event, index)" 
                ref="otpInput" :disabled="passwordForgotStep !== 'code'" />
        </div>
      
        <input
          v-model="password"
          type="password"
          placeholder="Nouveau mot de passe"
          :style="validationErrors.password ? errorStyles : defaultStyles"
          @blur="validateField('password', passwordPattern)"
          v-else-if="passwordForgotStep === 'password'"
        />
        <div style="display: flex; justify-content: space-between;"  v-if="!loading" >
          <button :style="secondaryButtonStyles" @click="goBack">
            <strong>Retour</strong>
        </button>
          <button :style="buttonStyles" @click="continueOTP">
            Continuer
          </button>
        </div>
        <div
          v-else
          style="display: flex; justify-content: center; align-items: center"
        >
          <div class="loader-container">
            <div class="loader"></div>
          </div>
        </div>
        
        <p
          v-if="submitError"
          style="
            color: red;
            font-size: 0.6em;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <!-- TODO : pull from i18n instead -->
          <i>
            {{ submitError }}
          </i>
        </p>
       
      </div>
  
    </div>
  </template>
  
  <script>
  import { customLogger } from "../../utils";
  import FormHeader from "../customs/FormHeader_Formacast.vue";
  
  
  export default {
    name: "LoginForm",
    components: {
      FormHeader,
    },
    props: {
      trigger: {
        type: Function,
        required: false,
        default: () => {
          customLogger("Redirect Called");
        },
      },
      /**
       * @param {string} redirect - name of the redirect to change to
       * @return {void}
       */
      redirect: {
        type: Function,
        required: false,
        default: () => {
          customLogger("Redirect Called");
        },
      },
    },
    data() {
      return {
        passwordForgotStep : "email", 
        email: "",
        code: "",
        password: "",
        otp: Array(6).fill(''),
        submitError: null,
        validationErrors: {
          email: false,
          otp: [false, false, false, false, false, false] 
        },
        emailPattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        codePattern: /^[0-9]{6}$/,
        passwordPattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
        errorStyles: {
          color: "red",
          border: "1px solid red",
          borderRadius: "1em",
          transition: "0.3s ease-in-out",
        },
        defaultStyles: {
          transition: "0.3s ease-in-out",
          color: "#747474",
          border: "1px solid #747474",
          borderRadius: "1em",
          backgroundColor: "transparent",
        },
        loading: false,
      };
    },
    computed: {
      isFormValid() {
        return true
      },
      secondaryButtonStyles() {
        return {
          transition: "0.3s ease-in-out",
          backgroundColor: "transparent",
          padding: "10px 15px",
          color: "red",
          borderRadius: "25px",
          margin: "0.5em auto",
          border: "none",
          cursor: this.isFormValid ? "pointer" : "default",
          width: "7em",
          border: "1px solid red",
          "text-align": "-webkit-center"
        };
      },
      buttonStyles() {
        return {
          transition: "0.3s ease-in-out",
          backgroundColor: this.isFormValid ? "#264c78" : "#d3d3d3",
          padding: "10px 15px",
          color: this.isFormValid ? "white" : "#a9a9a9",
          borderRadius: "25px",
          margin: "0.5em auto",
          border: "none",
          cursor: this.isFormValid ? "pointer" : "default",
          width: "15em",
          "text-align": "-webkit-center"
        };
      },
    },
    watch: {
      passwordForgotStep(newValue, oldValue) {
        customLogger('myData changed from', oldValue, 'to', newValue);
        
      }
    },
  
    methods: {
      /**
       * @param {string} fieldName - name of the field to validate
       * @param {RegExp} pattern - pattern to validate the field against
       */
       validateField(fieldName, pattern) {
           let fieldData = fieldName === 'code' ? this.otp.join('') : this[fieldName];
            if (!pattern.test(fieldData)) {
              this.$set(this.validationErrors, fieldName, true);
          } else {
              this.$set(this.validationErrors, fieldName, false);
          }
  },
  
  
      /***
       * @param {object} data - data to be sent to the server
       * @param {string} data.email - email of the user
       * @param {string} data.password - password of the user
       * @returns {Promise<void>} - returns a promise that resolves when the login is successful
       **/
   
       async forgotPassword() {
        if (!this.email) return;
        this.loading = true;
        try {
          const response = await this.$store.dispatch("SEND_OTP_FORGOT_PASSWORD", this.email);
          this.passwordForgotStep = "code";
        } catch (error) {
          this.submitError = "L'adresse e-mail spécifiée n'existe pas"
            setTimeout(()=>{
              this.submitError = null
            }, 5000)      }
        this.loading = false;
  
  
      },
  
  
      async continueOTP() {
        let isValid = true; 
  
          if (this.passwordForgotStep === "email") {
          this.forgotPassword();
          } else if (this.passwordForgotStep === "code") {
                this.validationErrors.otp = this.otp.map(code => code.trim() === ''); 
                isValid = !this.validationErrors.otp.includes(true); 
  
          if (isValid) {
                await this.verifyCode(); 
           } else {
               this.submitError = "Veuillez remplir tous les champs du code OTP."; 
                setTimeout(() => {
          this.submitError = null;
        }, 5000);
      
           }      } 
           else if (this.passwordForgotStep === "password") {
               this.resetPassword();
        }
      },
  
      async verifyCode() {
          const otpCode = this.otp.join('');
          if (!otpCode) return; 
            this.loading = true;
        try {
             const response = await this.$store.dispatch("VERIFY_OTP_EMAIL", {
             email: this.email,
             otp: otpCode, 
             type: "password_forgot"
            });
         if(response.success) {
             this.passwordForgotStep = "password";
         } else {
             this.submitError = "Le code OTP saisi est incorrect. Veuillez réessayer."
          setTimeout(() => {
             this.submitError = null;
            }, 5000);
      }
    } catch (error) {
      customLogger(error);
      this.submitError = "Une erreur est survenue. Veuillez réessayer.";
      setTimeout(() => {
        this.submitError = null;
      }, 5000);
    }
    this.loading = false;
  },
  
  
      async resetPassword() {
        if (!this.password) return;
        this.loading = true;
        try {
          const response = await this.$store.dispatch("UPDATE_PASSWORD", {
            email: this.email,
            newPassword: this.password,
          });
          if(response.success){
            this.trigger();
          }
          customLogger(response);
        } catch (error) {
          customLogger(error);
          return this.submitError = error.message;
        }
        this.loading = false;
      },
  
      onOtpInput(event, index) {
        const value = event.target.value;
        this.otp[index - 1] = value.replace(/[^0-9]/g, '');
        if (value && index < 6) {
            this.$refs.otpInput[index].focus();  
       }
    },
    goBack(){
    switch(this.passwordForgotStep){
      case "code":
        this.passwordForgotStep = "email"
        break;
      case "password" :
        this.passwordForgotStep = "code"
        break;
      default :
        this.trigger()
        break;
      }
  
    },
    },
  };
  </script>
  
